import { FormatCurrencyInterface } from "../entities/Common";
import { currencySeparatorValue } from "../entities/OperationalCountry";
import { OPERATIONAL_CURRENCY_SYMBOL_POSITION } from "../entities/OperationalCurrency";

const formatCurrencyAmountBySeparator = (
  amount: number | null,
  currencySeparator: string,
) => {
  if (amount === null) {
    return 0;
  }
  return amount.toString().replace(".", currencySeparator);
};

export const formatCurrency = ({
  amount,
  country,
  amountLabel,
}: FormatCurrencyInterface) => {
  if (country) {
    const currencyShortNameByCountry =
      amountLabel ?? country.currency.shortName;
    const currencySymbolPosition = country.currency.symbolPosition;
    const currencySeparator = currencySeparatorValue[country.currencySeparator];

    const formattedCurrencyAmount = formatCurrencyAmountBySeparator(
      amount,
      currencySeparator,
    );

    if (currencySymbolPosition === OPERATIONAL_CURRENCY_SYMBOL_POSITION.LEFT) {
      return `${currencyShortNameByCountry} ${formattedCurrencyAmount}`;
    }

    if (currencySymbolPosition === OPERATIONAL_CURRENCY_SYMBOL_POSITION.RIGHT) {
      return `${formattedCurrencyAmount} ${currencyShortNameByCountry}`;
    }
  }

  return amount;
};
